<script setup>
import CitationColumnHeader from "@/components/citations/partials/ui/CitationColumnHeader.vue";
import CitationColumn from "@/components/citations/partials/ui/CitationColumn.vue";
import ColumnCard from "@/components/citations/partials/ui/ColumnCard.vue";
import CitationCard from "@/components/citations/partials/ui/CitationCard.vue";
import CitationStatuses from "@/components/citations/partials/CitationStatuses.vue";
import EmptyStateCard from "@/components/citations/partials/ui/EmptyStateCard.vue";
import {getCitations} from "@/composables/citations/useCitations";
import ErrorState from "@/components/citations/partials/ErrorState.vue";
import ReportProcessing from "@/components/citations/partials/ReportProcessing.vue";
import NoResultsState from "@/components/citations/partials/NoResultsState.vue";
import LoadingState from "@/components/citations/partials/LoadingState.vue";
import {computed} from "vue";

const props = defineProps({
  isGbpLocation: {
    type: Boolean,
    required: true,
  },
});

const {data, isError, isPending} = getCitations(props.isGbpLocation);
const noResults = computed(() => data?.total_listings_count === 0);
</script>

<template>
  <ErrorState v-if="isError" />
  <LoadingState v-else-if="isPending" />
  <NoResultsState v-else-if="noResults" />
  <ReportProcessing v-else-if="!data.report_finished" />

  <div
    v-else
    class="tw-bg-white tw-p-8 tw-rounded-lg"
  >
    <div class="tw-grid tw-grid-cols-3 tw-gap-x-8">
      <CitationColumn>
        <CitationColumnHeader
          icon="in-sync"
          :count="data.accurate_listings?.length ?? 0"
        >
          Listings are accurate
        </CitationColumnHeader>

        <ColumnCard>
          <CitationCard
            v-for="(citation, index) in data.accurate_listings"
            :key="index"
            :logo-url="citation.directory_logo_url"
            :directory-name="citation.directory_type"
          >
            <CitationStatuses :citation="citation" />
          </CitationCard>

          <EmptyStateCard v-if="data.accurate_listings?.length === 0" />
        </ColumnCard>
      </CitationColumn>

      <CitationColumn>
        <CitationColumnHeader
          icon="not-in-sync"
          :count="data.errored_listings?.length"
        >
          Listings have errors
        </CitationColumnHeader>

        <ColumnCard>
          <CitationCard
            v-for="(citation, index) in data.errored_listings"
            :key="index"
            :logo-url="citation.directory_logo_url"
            :directory-name="citation.directory_type"
          >
            <CitationStatuses :citation="citation" />
          </CitationCard>

          <EmptyStateCard v-if="data.errored_listings?.length === 0" />
        </ColumnCard>
      </CitationColumn>

      <CitationColumn>
        <CitationColumnHeader
          icon="not-found"
          :count="data.not_found_listings?.length"
        >
          Not listed yet
        </CitationColumnHeader>

        <ColumnCard>
          <CitationCard
            v-for="(citation, index) in data.not_found_listings"
            :key="index"
            :logo-url="citation.directory_logo_url"
            :directory-name="citation.directory_type"
          >
            <CitationStatuses :citation="citation" />
          </CitationCard>

          <EmptyStateCard v-if="data.not_found_listings?.length === 0" />
        </ColumnCard>
      </CitationColumn>
    </div>
  </div>
</template>
